export default __webpack_public_path__ + "static/media/backgroundimage.31bc3e02.jpg";